var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import { string } from 'prop-types';
import styled from 'styled-components';
var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  width: 100%;\n"])));

var Step = function Step(props) {
  return /*#__PURE__*/React.createElement(Wrapper, props);
};

Step.propTypes = {
  /** Label to be displayed below the stepper dot. */
  label: string.isRequired
};
Step.displayName = 'Stepper.Step';
export default Step;